import { RACE_TYPE_LABELS, MONTH_NAMES_PT, cn } from '../lib/utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export const FilterPills = ({ 
  activeType, 
  setActiveType, 
  activeMonth, 
  setActiveMonth,
  activeDistrict,
  setActiveDistrict,
  districts = []
}) => {
  const types = [
    { value: null, label: 'Todas' },
    { value: 'road', label: RACE_TYPE_LABELS.road },
    { value: 'trail', label: RACE_TYPE_LABELS.trail },
    { value: 'walk', label: RACE_TYPE_LABELS.walk },
    { value: 'kids', label: RACE_TYPE_LABELS.kids },
  ];

  const months = [
    { value: null, label: 'Todos os meses' },
    ...MONTH_NAMES_PT.map((name, i) => ({ value: i + 1, label: name }))
  ];

  return (
    <div className="space-y-4">
      {/* Type filters */}
      <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar" data-testid="type-filters">
        {types.map((type) => (
          <button
            key={type.value || 'all'}
            onClick={() => setActiveType(type.value)}
            className={cn(
              'filter-pill whitespace-nowrap',
              activeType === type.value && 'active'
            )}
            data-testid={`filter-type-${type.value || 'all'}`}
          >
            {type.label}
          </button>
        ))}
      </div>

      {/* Month and District filters */}
      <div className="flex flex-wrap gap-2">
        {/* Month select */}
        <Select
          value={activeMonth ? String(activeMonth) : 'all'}
          onValueChange={(value) => setActiveMonth(value === 'all' ? null : parseInt(value))}
        >
          <SelectTrigger className="w-[180px] rounded-full" data-testid="filter-month">
            <SelectValue placeholder="Todos os meses" />
          </SelectTrigger>
          <SelectContent>
            {months.map((month) => (
              <SelectItem key={month.value || 'all'} value={month.value ? String(month.value) : 'all'}>
                {month.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* District select */}
        <Select
          value={activeDistrict || 'all'}
          onValueChange={(value) => setActiveDistrict(value === 'all' ? null : value)}
        >
          <SelectTrigger className="w-[180px] rounded-full" data-testid="filter-district">
            <SelectValue placeholder="Todos os distritos" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os distritos</SelectItem>
            {districts.map((district) => (
              <SelectItem key={district} value={district}>
                {district}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default FilterPills;
